import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet-async';

const RouteWrapper = function({component: Component, title, content, name, ...rest}) {
  const imageUrl = `${window.location.origin}/meta-image.jpg`;

  return (
    <>
      <Helmet prioritizeSeoTags>
        <link
          href={window.location.href}
          rel='canonical'/>
        {title && <title>{title}</title>}
        {content && name && <meta
          content={content}
          name={name}/>}
        <meta
          content='Decision Aid for Chronic Kidney Disease & Signs of Coronary Heart Disease'
          name='description'/>
        <meta
          content={title || 'My Page Title'}
          property='og:title'/>
        <meta
          content='Decision Aid for Chronic Kidney Disease & Signs of Coronary Heart Disease'
          property='og:description'/>
        <meta
          content={imageUrl}
          property='og:image'/>
        <meta
          content={window.location.href}
          property='og:url'/>
        <meta
          content={title || 'Kidney Decision Aid'}
          name='twitter:title'/>
        <meta
          content='Decision Aid for Chronic Kidney Disease & Signs of Coronary Heart Disease'
          name='twitter:description'/>
        <meta
          content={imageUrl}
          name='twitter:image'/>
        <meta
          content='summary_large_image'
          name='twitter:card'/>
      </Helmet>
      <Component {...rest}/>
    </>
  );
};

RouteWrapper.propTypes = {
  component: PropTypes.elementType.isRequired,
  content: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string
};

RouteWrapper.defaultProps = {
  content: '',
  name: '',
  title: ''
};

export default RouteWrapper;
